import React from "react";
import { framework_tool, component_tool, utils_tool } from '../../../../tool'
import { WizTableForm } from "../../../common";

let { WizDataTable, WizButton, WizPopover } = component_tool
const organizationConfig = WizTableForm.Config.organization(this, { apiParams: { state: 1 } })
const positionConfig = WizTableForm.Config.position(this, { apiParams: { state: 1 } })


export default (self, type, info) => {
  let columns = []
  columns = columns.concat([
    {
      name: 'id',
    },
    {
      name: 'practiceId'
    },
    {
      title: '姓名',
      name: 'fullName',
      searchItem: {},
      tableItem: {}
    },
    {
      title: '账号',
      name: 'userName',
      searchItem: {},
      tableItem: {}
    },
    {
      title: '组织',
      name: 'orgId',
      searchItem: {
        ...organizationConfig,
        diy: WizTableForm,
        selectType: 'radio',
      }
    },
    {
      title: '岗位',
      name: 'positionId',
      searchItem: {
        ...positionConfig,
        diy: WizTableForm,
        selectType: 'radio',
      },
    },
    {
      title: '账号状态',
      name: 'accountState',
      tableItem: {},
      dict: [
        { code: 1, codeName: "激活" },
        { code: 0, codeName: "禁用" }
      ]
    },
    {
      title: '任职信息',
      name: 'userIdentityInfoList',
      tableItem: {
        width: 200,
        render: (val = [], record) => {
          if (!val.length) { return '暂无任职' }
          let { orgName, positionName } = val[0]
          let _titleView = [`${orgName}-${positionName}`]
          if (val.length > 1) {
            _titleView.push(<span className='manager-person-text-color'> ...</span>)
          }
          return (
            <WizPopover
              content={val.map((e) => <p>{`${e['orgName']}-${e['positionName']}`}</p>)}
              placement="rightTop"
            >
              {_titleView}
            </WizPopover>
          )
        }
      }
    },
  ])
  if (type !== 'detail') {
    columns = columns.concat([
      {
        title: '练习天数',
        name: 'days',
        tableItem: {}
      },
      {
        title: '练习次数',
        name: 'count',
        tableItem: {}
      },
      {
        title: '平均正确率',
        name: 'avgAccuracy',
        tableItem: {
          render: (text, record) => {
            return text + '%'
          }
        }
      },
      {
        title: '最优正确率',
        name: 'maxAccuracy',
        tableItem: {
          render: (text, record) => {
            return text + '%'
          }
        }
      },
      {
        title: '平均练习时长(秒)',
        name: 'avgDuration',
        tableItem: {}
      },
      
    ])
  } else {
    columns = columns.concat([
      {
        title: '日期',
        name: 'practiceDate',
        searchItem: {
          type: 'date~',
          showTime: true,
          format: 'YYYY-MM-DD HH:mm'
        }
      },
      {
        title: '练习开始时间',
        name: 'startDate',
        tableItem: {}
      },
      {
        title: '练习结束时间',
        name: 'endDate',
        tableItem: {}
      },
      {
        title: '答题时长(秒)',
        name: 'duration',
        tableItem: {}
      },
      {
        title: '答对题数',
        name: 'correctNum',
        tableItem: {}
      },
      {
        title: '习题数量',
        name: 'questionNum',
        tableItem: {}
      },
      {
        title: '正确率',
        name: 'accuracy',
        tableItem: {
          render: (text, record) => {
            return text + '%'
          }
        }
      },
      {
        title: '操作',
        tableItem: {
          render: (text, record) => (
            <WizDataTable.Oper>
              <WizButton tooltip="查看习题" onClick={e => self._onLook(record, e)}>
                查看习题
              </WizButton>
            </WizDataTable.Oper>
          )
        }
      }
    ])
  }

  return columns
}
